import React from 'react';
import "./styles.css";
import {
  TextField,
  Grid,
  Typography,
} from "@mui/material";

const AddressDetails = () => {
  return (
  
  < Grid  className='address_container' sx={{padding:'20px', marginTop: "19px", 
  border: '1px solid #E3E3E3', backgroundColor: '#FCFCFC',background: "#FCFCFC 0% 0% no-repeat", boxShadow: "0px 3px 6px #A7A7A729",
  borderRadius: "6px" }}>
    <Typography style={{fontWeight:'600',color:'#000000', fontFamily: 'Rubik'
  }}>
Address details
</Typography>
<Grid  sx={ {display:'flex', flexDirection:'row',marginTop:'1%'}}>

      <Grid sx={ {display:'flex', flexDirection:'column'}} >
        <Grid  sx={ {display:'flex', flexDirection:'column',paddingBottom:'7%'}}>
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px'}}>
          House/Apartment Number
        </label>
        <TextField
        className='address_container'
          style={{ fontFamily: 'Rubik' }}
          InputProps={{ readOnly: true, style: {
            backgroundColor: "white"                 
          } }}
          size="small"
          disabled={false}
          focused={false}
          // placeholder="Add Last Name"
          value={'303'}
          sx={{width:'270px'}}
        
        />
        </Grid>
        <Grid  sx={ {display:'flex', flexDirection:'column'}}>
       
      
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px' }}>
          City
        </label>
        <TextField
         className='address_container'
          style={{ fontFamily: 'Rubik' }}
          InputProps={{ readOnly: true, style: {
            backgroundColor: "white"                 
          } }}
          size="small"
          disabled={false}
          focused={false}
          // placeholder="Add Last Name"
          value={'Patna'}
          sx={{width:'270px'}}
        />
        </Grid>
        </Grid>
        <Grid sx={ {display:'flex', flexDirection:'column', marginLeft:'auto'}} >
        <Grid  sx={ {display:'flex', flexDirection:'column',paddingBottom:'7%'}}>
        
      
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px' }}>
          Landmark
        </label>
        <TextField
         className='address_container'
          style={{ fontFamily: 'Rubik' }}
          InputProps={{ readOnly: true, style: {
            backgroundColor: "white"                 
          } }}
          size="small"
          disabled={false}
          focused={false}
          placeholder="Add Last Name"
          value={'Near Gandhi Murti'}
          sx={{width:'270px'}}
        />
        </Grid>
        <Grid  sx={ {display:'flex', flexDirection:'column'}}>
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px' }}>
          Province
        </label>
      
       
        <TextField
         className='address_container'
          style={{ fontFamily: 'Rubik' }}
          InputProps={{ readOnly: true, style: {
            backgroundColor: "white"                 
          } }}
          size="small"
          placeholder="Add Last Name"
          value={'Delhi'}
          disabled={false}
          focused={false}
          sx={{width:'270px'}}
        />
        </Grid>
        </Grid>

        <Grid  sx={ {display:'flex', flexDirection:'column', marginLeft:'auto'}}>
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px' }}>
          Street/Area Name
        </label>
      
       
        <TextField
         className='address_container'
          style={{ fontFamily: 'Rubik' }}
          InputProps={{ readOnly: true, style: {
            backgroundColor: "white"                 
          } }}
          size="small"
          disabled={false}
          focused={false}
          placeholder="Add Last Name"
          value={'New Area'}
          sx={{width:'270px'}}
        />
        </Grid>
      
        </Grid>
        </Grid>

   


  )
}

export default AddressDetails;